// extracted by mini-css-extract-plugin
module.exports = {"button":"_3Zzfzpfs-saY-QWa8vBAD-"};